import styled, { css } from "styled-components";
import { token } from "./token.js";
const baseStyles = css(["color:", ";font-size:", ";font-family:", ";line-height:", ";"], token.colorText, token.fontSizeBase, token.brandFontStackBase, token.lineHeightBase);
const BaseStyles = styled.div.withConfig({
  displayName: "BaseStyles",
  componentId: "sc-9qrbu4-0"
})(["", ""], baseStyles);
export {
  BaseStyles,
  baseStyles
};
//# sourceMappingURL=BaseStyles.js.map
